export const DRIVING_LICENSE = 'drivingLicence';
export const MEDICARE = 'medicare';
export const PASSPORT = 'passport';

export const identDocumentTypes = [
  { type: DRIVING_LICENSE, title: 'ident_document.driving_licence', intl: true },
  { type: MEDICARE, title: 'ident_document.medicare', intl: true },
  { type: PASSPORT, title: 'ident_document.passport', intl: true },
];

export const identDocumentTypesValues = identDocumentTypes.map((item) => item.type);
